import { render, staticRenderFns } from "./SwapLockedAmount.vue?vue&type=template&id=53f60798&scoped=true"
import script from "./SwapLockedAmount.vue?vue&type=script&lang=ts"
export * from "./SwapLockedAmount.vue?vue&type=script&lang=ts"
import style0 from "./SwapLockedAmount.vue?vue&type=style&index=0&id=53f60798&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f60798",
  null
  
)

export default component.exports